import { render, staticRenderFns } from "./data-list.vue?vue&type=template&id=e1c52e0e&scoped=true&"
import script from "./data-list.vue?vue&type=script&lang=js&"
export * from "./data-list.vue?vue&type=script&lang=js&"
import style0 from "./data-list.vue?vue&type=style&index=0&id=e1c52e0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1c52e0e",
  null
  
)

export default component.exports